import React from 'react'
import { ScreenReaderOnly } from '@moonpig/launchpad-components'
import { useCustomerFirstName } from '@moonpig/web-shared-utils'
import { StyledIntroBox, StyledIntroGreeting, StyledIntroText } from './styled'
import { useLocaleText } from '../../locale'

export const ChatIntro = () => {
  const t = useLocaleText()
  const firstName = useCustomerFirstName()
  const introText = t('concierge_chat.intro_title')
  const labelId = 'chat-intro-message-label'
  const greetingId = 'chat-intro-message-greeting'
  const introTextId = 'chat-intro-message-text'
  const hasFirstName = Boolean(firstName)
  const ariaLabelledBy = hasFirstName
    ? `${labelId} ${greetingId} ${introTextId}`
    : `${labelId} ${introTextId}`

  return (
    <StyledIntroBox
      aria-labelledby={ariaLabelledBy}
      data-testid="chat-intro-message"
      role="article"
    >
      <ScreenReaderOnly id={labelId}>
        {t('concierge_chat.screen_reader_assistant_label')}
      </ScreenReaderOnly>
      {hasFirstName && firstName ? (
        <StyledIntroGreeting
          data-testid="chat-intro-greeting"
          id={greetingId}
          as={'h3'}
        >
          {t('concierge_chat.intro_greeting', { firstName })}
        </StyledIntroGreeting>
      ) : null}
      <StyledIntroText
        $hasFirstName={hasFirstName}
        data-testid="chat-intro-text"
        id={introTextId}
        as={'p'}
      >
        {introText}
      </StyledIntroText>
    </StyledIntroBox>
  )
}
